import $ from 'jquery'
import { Site } from './Site'

class Main {
  constructor() {
    $(this.init.bind(this))
  }

  private init() {
    new Site()
  }
}

new Main()
